import type { VersionDetailItem } from '@/utils/types/flavorVersion';

/**
 * Derive a stable identifier string for an export row.
 *   1. CAS (compound_alias.alias_value, when present) — preferred.
 *   2. InChIKey — fallback for compounds without a CAS alias.
 *   3. Synthetic last-resort: '<kind>:<id>'.
 *
 * Per-supplier catalog numbers are NOT included in v1 — that would require a
 * supplier selector in the Export popover. Spec §4 marks this as a v2 follow-up.
 */
export function exportIdentifier(row: VersionDetailItem): string {
  if (row.identifier) return row.identifier;
  if (row.inchikey)   return row.inchikey;
  return `${row.substanceKind}:${row.substanceId}`;
}
